<template>
  <ul id="klickbox-step-list" class="kp-list-group submenu-no-padding">
    <draggable
      :list="list"
      :options="{ filter: '.nondraggable' }"
      @end="onDragEnd($event, list)">
      <li
        class="kp-list-group-item"
        draggable
        v-for="(step, index) in list"
        @click="stepSetActive(step);canvasChangeView('steps')"
        :id="step.id"
        :class="{ active: stepActive.id === step.id, nondraggable: step.kind === 'thanks' }">

        <span class="kp-list-num" v-if="step.kind === 'thanks'">
          <i class="kp-panel-flag"></i>
        </span>

        <span class="kp-list-num" v-if="step.kind === 'welcome'">
          <i v-if="step.welcome_active" class="kp-panel-home"></i>
          <i v-else style="color: #e74c3c; opacity: 0.2" class="fa fa-times"></i>
        </span>

        <span class="kp-list-num" v-if="step.kind != 'thanks' && step.kind != 'welcome'">
          {{ stepDisplayPosition(step) }}
        </span>

        <div class="kp-row" :class="'kp-row-' + step.kind" style="float: left; width: 219px">
          <span class="kp-list-label">
            <step-icon :step="step"></step-icon>
            {{ step.sanitized_title }}
          </span>
          <span class="kp-list-text" v-if="step.kind === 'welcome'">
            {{ $t('general.labels.first').toUpperCase() }} {{ $t('general.labels.step').toUpperCase() }}
          </span>

          <span class="kp-list-text" v-if="step.kind === 'thanks'">
            {{ $t('general.labels.last').toUpperCase() }} {{ $t('general.labels.step').toUpperCase() }}
          </span>
        </div>
        <div class="klickbox-step-buttons" style="float: left; width: 219px">
          <button-jump :step="step"></button-jump>
          <button-duplicate :step="step"></button-duplicate>
          <button-delete :step="step"></button-delete>
        </div>
      </li>
    </draggable>
  </ul>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import StepIcon from '../Icon.vue';
import draggable from 'vuedraggable';
import ButtonDuplicate from './ButtonDuplicate.vue';
import ButtonJump from './ButtonJump.vue';
import ButtonDelete from './ButtonDelete.vue';

export default {
  components: {
    StepIcon,
    draggable,
    ButtonDuplicate,
    ButtonJump,
    ButtonDelete,
  },
  computed: {
    list() {
      return this.steps.slice(0);
    },
    ...mapGetters({
      steps: 'stepList',
      stepActive: 'stepActive',
      stepDisplayPosition: 'stepDisplayPosition',
    }),
  },
  methods: {
    onDragEnd(event, list) {
      if (event.newIndex === list.length - 1) {
        return false;
      }

      this.stepUpdateOrder({ event, list });
      return true;
    },
    ...mapActions([
      'stepSetActive',
      'stepUpdateOrder',
      'canvasChangeView',
    ]),
  },
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?5517e988
 **/